import { render, staticRenderFns } from "./EventCatalogPlacement.vue?vue&type=template&id=f800ce32"
import script from "./EventCatalogPlacement.vue?vue&type=script&lang=js"
export * from "./EventCatalogPlacement.vue?vue&type=script&lang=js"
import style0 from "./EventCatalogPlacement.vue?vue&type=style&index=0&id=f800ce32&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports